<template>
  <div class="outer-wrapper">
    <div v-if="error" class="inner-wrapper">
      <h3>
        {{ error }}
      </h3>
    </div>
  </div>
</template>

<script>
import { parseUserLogin } from '@/utils/auth';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';

export default {
  name: 'ReceiveLogin',
  mixins: [BehaviorLogMixin],
  components: {},
  data() {
    return {
      error: null,
    };
  },
  async created() {
    if (this.$route.query.error) {
      this.error = this.$route.query.error_description;
    } else {
      const redirect = await parseUserLogin();
      if (redirect) {
        window.location = redirect;
      } else {
        this.$router.push('/');
      }
    }
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
.inner-wrapper {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;

  h3 {
    color: red;
    text-align: center;
  }
}
</style>
